import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core/";
import IntlMessages from "util/IntlMessages";
import Select from "react-select";
import {
  fetch_patients as fetch_patients_action,
  update_sample_patient,
} from "actions/patients";

const samplePatientUpload = (props) => {
  const {
    patients: {
      fetch_patients_summary_data: [
        {
          device_id,
          timezone,
          recording_date,
          recording_start_time,
          recording_stop_time,
        },
      ],
    },
  } = props;
  useEffect(() => {
    if (props.patients.sample_patient_list.length <= 0) {
      props.fetch_patients([{ user_id: "2112" }]);
    }
  }, []);

  const [patientSelected, setPatientSelected] = useState(true);
  const [samplePatient, setSamplePatient] = useState({});

  const onConfirm = () => {
    props.update_sample_patient({
      physician_id: "2112", //sample_patient physician id,
      device_id: device_id,
      timezone: timezone,
      user_id: samplePatient.id,
      recording_date: recording_date,
      recording_start_time: recording_start_time,
      recording_stop_time: recording_stop_time,
    });

    props.onCancel();
  };

  let options = [];
  props.samplePatients &&
    props.samplePatients.forEach((sp) => {
      let tempObj = {};
      if (sp) {
        tempObj.label = sp.patient_code;
        tempObj.value = sp.patient_code;
        tempObj.id = sp.user_id;
        tempObj.physician_id = sp.created_by;
      }
      options.push(tempObj);
    });

  return (
    <Dialog
      className="custom-popup confirm-popup"
      PaperProps={{ classes: { root: "custom-popup-root" } }}
      open={true}
      onClose={props.onCancel}
      scroll={"paper"}
      disableBackdropClick={true}
    >
      <div className="popup-wrap">
        <div className="popup-header">
          <DialogTitle className="popup-title">
            <IntlMessages id="logout.alert" />
          </DialogTitle>
        </div>
        <DialogContent className="popup-content">
          <div
            style={{ display: "flex", flexDirection: "column" }}
          >{`Please select a sample patient to upload `}</div>

          <Select
            onChange={(sp) => {
              setPatientSelected(false);
              setSamplePatient(sp);
            }}
            value={samplePatient}
            options={options}
            placeholder="Please select"
            className="comment-textarea mb-5"
          />
        </DialogContent>
        <DialogActions className="popup-footer">
          <Button
            onClick={props.onCancel}
            className="secondary-button"
            disableRipple={false}
            disableFocusRipple={false}
          >
            <IntlMessages id="main.cancel" />
          </Button>
          {!patientSelected && (
            <Button
              onClick={onConfirm}
              className="primary-button"
              disableRipple={false}
              disabled={patientSelected}
              disableFocusRipple={false}
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetch_patients: (params) => dispatch(fetch_patients_action(params)),
  update_sample_patient: (payload) => dispatch(update_sample_patient(payload)),
});

const mapStateToProps = (state) => ({
  ...state.patients,
  patients: state.patients,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(samplePatientUpload);
